

export const showError = (message: unknown) => console.log(message)